import { createSlice, type PayloadAction } from "@reduxjs/toolkit/react";

export interface CommonSliceState {
  lang?: string;
  siteName?: string;
}

const initialState: CommonSliceState = {
  lang: undefined,
  siteName: undefined,
};

export const commonSlice = createSlice({
  name: "common",
  initialState,
  reducers: {
    setLanguage(state, payload: PayloadAction<string>) {
      state.lang = payload.payload;
    },
    setSiteName(state, payload: PayloadAction<string>) {
      state.siteName = payload.payload;
    },
  },
});

export const { setLanguage, setSiteName } = commonSlice.actions;
